import React, { useEffect, useState } from "react";

import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import styles from "../RawData/Header/Header.module.sass";
import {
    SovosTab,
    SovosTabs,
    SovosToolbar,
    SovosToolbarActions,
    SovosToolbarDropdown,
    SovosMenuItem,
} from "mosaic-react";

import SovosMonthSelector from "colbi_web_ui/lib/components/layout/YearSelector/index.js";
import { regexURLMatcher } from "colbi_web_ui/lib/utils/routingUtils.js";
import { formatImportIdDisplayLabel } from "../../utils/importIdUtils";

const HeaderNewNavigation = (props) => {
    const {
        fiscalYears,
        importIds,
        viewMode: viewModeProp,
        onViewModeChange,
        disableLegalTab = false,
        hideFiscalYearSelector = false,
    } = props;

    const viewMode = viewModeProp || "source";

    const handleViewModeChange = (newValue) => {
        if (onViewModeChange && typeof onViewModeChange === "function") {
            onViewModeChange(newValue);
        }
    };

    const { history, params, i18n } = useGlobalValue();
    const { importId: currentImportId } = params || {};
    const [currentFiscalYears, setCurrentFiscalYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null);

    useEffect(() => {
        if (fiscalYears && typeof fiscalYears === "object") {
            const yearsArray = Object.keys(fiscalYears).map((year) => parseInt(year));
            setCurrentFiscalYears(yearsArray);
        }
    }, [fiscalYears]);

    useEffect(() => {
        if (history?.location) {
            const myRegex1 =
                /^(\/(pt|en|lt|es|ro|fr)\/\d+\/)(\d{4}|current)\/?(\d+|full)?(\/.*\/)?([^/]+)?$/;

            const match = regexURLMatcher(myRegex1, history?.location?.pathname || "");
            if (match) {
                const group3 = match[3];
                setSelectedYear(+group3);
            }
        }
        // eslint-disable-next-line
    }, [JSON.stringify(history)]);

    return (
        <div key="mainDiv">
            <div className={`${styles["header-root"]}`}>
                <div className={`${styles["toolbar-container"]}`}>
                    <div className={`${styles["view-toggle"]}`} role="tablist" aria-label="View mode selector">
                        <SovosTabs
                            value={viewMode}
                            onChange={(_, newValue) => handleViewModeChange(newValue)}
                        >
                            <SovosTab value="source" label={i18n`Source`} />
                            {!disableLegalTab && <SovosTab value="legal" label={i18n`Legal`} />}
                        </SovosTabs>
                    </div>
                    {!hideFiscalYearSelector && Array.isArray(importIds) && (
                        <SovosMonthSelector
                            className={`${styles["sovos-month-selector"]}`}
                            format={"number"}
                            selectedYear={+selectedYear}
                            nextMonthTooltipText={"Next"}
                            previousMonthTooltipText={"Previous"}
                            years={currentFiscalYears}
                            minDate={new Date(`${currentFiscalYears[0]}-01-01`)}
                            maxDate={
                                new Date(
                                    `${currentFiscalYears[currentFiscalYears.length - 1]}-12-31`,
                                )
                            }
                            onChange={(e) => {
                                const newYear = e.year;
                                const currentData = fiscalYears[newYear];
                                // fiscalYears is { "2024": { source: [...], legal: [...] } }
                                // fall back to flat array for backward compatibility
                                const ids = Array.isArray(currentData)
                                    ? currentData
                                    : (currentData?.[viewMode] || Object.values(currentData || {})[0] || []);
                                let lastImportId;
                                if (ids.length) {
                                    const fiscalYearIds = ids.map((item) => item.id);
                                    lastImportId =
                                        fiscalYearIds.indexOf("full") !== -1
                                            ? "full"
                                            : Math.max(...fiscalYearIds);
                                }
                                const myRegex =
                                    /^(\/(pt|en|lt|es|ro|fr)\/\d+\/)(\d{4}|current)\/?(\d+|full)?(\/*.*)/;

                                const match = regexURLMatcher(myRegex, history.location.pathname);
                                if (match?.[4]) {
                                    history.push(
                                        history.location.pathname.replace(
                                            myRegex,
                                            `$1${newYear}/${lastImportId}$5`,
                                        ),
                                    );
                                } else {
                                    history.push(
                                        history.location.pathname.replace(
                                            myRegex,
                                            `$1${newYear}/$5`,
                                        ),
                                    );
                                }
                            }}
                        />
                    )}
                    {!hideFiscalYearSelector && Array.isArray(importIds) && importIds.length > 0 && (
                        <SovosToolbar className={`${styles["sovos-toolbar"]}`}>
                            <SovosToolbarActions className={`${styles["toolbar-actions"]}`}>
                                <SovosToolbarDropdown
                                    className={`${styles["toolbar-dropdown"]}`}
                                    value={currentImportId || "full"}
                                    onChange={(event) => {
                                        const newImportId = event.target.value;
                                        const myRegex =
                                            /^(\/(pt|en|lt|es|ro|fr)\/\d+\/)(\d{4}|current)\/?(\d+|full)?(\/*.*)/;
                                        const newPathname = history.location.pathname.replace(
                                            myRegex,
                                            `$1$3/${newImportId}$5`,
                                        );
                                        const searchParams = new URLSearchParams(
                                            history.location.search,
                                        );
                                        const newUrl = searchParams.toString()
                                            ? `${newPathname}?${searchParams.toString()}`
                                            : newPathname;
                                        history.push(newUrl);
                                    }}
                                >
                                    {importIds.map((importItem) => (
                                        <SovosMenuItem key={importItem.id} value={importItem.id}>
                                            {importItem.id === "full"
                                                ? formatImportIdDisplayLabel(importItem.id)
                                                : `${importItem.id} - ${importItem.name}`}
                                        </SovosMenuItem>
                                    ))}
                                </SovosToolbarDropdown>
                            </SovosToolbarActions>
                        </SovosToolbar>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HeaderNewNavigation;

